// 材料清单

import server from '../server'

const localStorage = window.localStorage
const access_token = localStorage.getItem('access_token') || 'YWRtaW46YWRtaW5fc2VjcmV0'
const token_type = localStorage.getItem('token_type') || 'Basic'

// 材料清单-基本清单-查询（分页）（李开明）
const selectMaterialPage = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/selectMaterialPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 查询材料分类树结构 （李开明）
const getTypeTree = function () {
    return server({
        method: 'post',
        url: 'sysDict/getTypeTree',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 新增或编辑材料（李开明）
const saveOrUpdateMaterial = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/saveOrUpdateMaterial',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料清单-发布清单-查询（分页）（李开明）
const selectMaterialPageByPublish = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/selectMaterialPageByPublish',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 发布清单的删除材料（李开明）
const deleteMaterialById = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/deleteMaterialById',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 发布清单中的添加发布材料的分页查询接口（李开明）
const selectMaterialsPage = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/selectMaterialsPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 发布材料-添加（李开明）
const materialBatchToPublish = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/materialBatchToPublish',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料清单-主要材料-条件查询（分页）（李开明）
const selectMainMaterialPage = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materialsDefine/selectMainMaterialPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料清单-主要材料-条件查询（分页）（李开明）
const deleteMainMaterial = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materialsDefine/deleteMainMaterial',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料清单-主要材料-条件查询（分页）（李开明）
const selectAddMainMaterialPage = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materialsDefine/selectAddMainMaterialPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 主要材料批量-添加（李开明）
const saveMainMaterial = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materialsDefine/saveMainMaterial',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料清单-预警清单-条件查询分页材料（郑志会）
const selectWarningListingPage = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/selectWarningListingPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 基本清单-导入的模板下载 （李开明）
const download = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/download',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 基本清单-导入的模板-保存操作 （李开明）
const headerSave = function (query) {
    return server({
        method: 'post',
        data: query,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token_type + ' ' + access_token
        },
        url: 'materials/headerSave'
    })
}

// 人工价 --- 查询工种列表 （王开国）
const getProList = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'professionInfo/queryPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 人工价 --- 保存工种 （王开国）
const savePro = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'professionInfo/save',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 人工价 --- 删除工种
const delPro = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'professionInfo/deleteById',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料组合 --- 增加/保存
const saveResourceCombina = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'resourceCombination/saveResourceCombina',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料组合 --- 删除
const deleteResourceCombination = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'resourceCombination/deleteResourceCombination',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 材料组合 --- 分页查询
const selectResourceCombinations = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'resourceCombination/selectResourceCombinations',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 基本材料删除
const deleteMaterial = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'materials/deleteMaterial',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}


// 省站——设置——分部工程分页查询
const getDivisionalPageList = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'fill/divisionalworks/getDivisionalPageList',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站——设置——工种设置分页查询
const getTypeWorkSetPageList = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'fill/typeworkset/getTypeWorkSetPageList',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站/市站——设置——大小工比例设置分页接口
const getLargeSmallWorkersProportionPageList = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'fill/largesmallworkersproportionset/getLargeSmallWorkersProportionPageList',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站/市站——设置——大小工比例设置接口
const saveLargeSmallWorkersProportionSet = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'fill/largesmallworkersproportionset/saveLargeSmallWorkersProportionSet',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站/市站——设置——大小工比例设置接口
const getLargeSmallWorkersProportionHistory = function (query) {
    return server({
        method: 'post',
        data: query,
        url: 'fill/largesmallworkersproportionset/getLargeSmallWorkersProportionHistory',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站-设置-合肥部分材料设置获取已选的材料列表
const getChoosedMaterials = function (query) {
    return server({
        method: 'post',
        data: query,
        url: '/materialsSetting/getChoosedMaterials',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站-设置-合肥部分材料设置保存已选的材料
const chooseMaterials = function (query) {
    return server({
        method: 'post',
        data: query,
        url: '/materialsSetting/chooseMaterials',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站-设置-合肥部分材料设置移除已选的材料
const deleteChoosedMaterials = function (query) {
    return server({
        method: 'post',
        data: query,
        url: '/materialsSetting/deleteChoosedMaterials',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 省站-设置-合肥部分材料设置排序已选的材料
const sortMaterials = function (query) {
    return server({
        method: 'post',
        data: query,
        url: '/materialsSetting/sortMaterials',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

export {
    selectMaterialPage, getTypeTree, saveOrUpdateMaterial, selectMaterialPageByPublish,
    deleteMaterialById, selectMaterialsPage, materialBatchToPublish, selectMainMaterialPage,
    deleteMainMaterial, selectAddMainMaterialPage, saveMainMaterial, selectWarningListingPage,
    download, headerSave, getProList, savePro, delPro, saveResourceCombina,
    selectResourceCombinations, deleteResourceCombination, deleteMaterial, getDivisionalPageList,
    getTypeWorkSetPageList, getLargeSmallWorkersProportionPageList, saveLargeSmallWorkersProportionSet,
    getLargeSmallWorkersProportionHistory, getChoosedMaterials, deleteChoosedMaterials, chooseMaterials,
    sortMaterials
}



// WEBPACK FOOTER //
// ./src/api/module/materialsBill.js